import { render } from "./AppProfile.vue?vue&type=template&id=6d5b8f28&scoped=true"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6d5b8f28"

export default script